const FieldSeperator = ({ title }) => {
  return (
    <div className="form-section-title">
      <div className="title">{title}</div>
      <div className="line"></div>
    </div>
  );
};

export default FieldSeperator;
